import React, { useEffect, useState } from "react";
import { FaEye, FaRegHeart, FaRegStar, FaStar } from "react-icons/fa";
import { FaCodeCompare } from "react-icons/fa6";
import { GrGrid, GrList, GrNext, GrPrevious } from "react-icons/gr";
import { RiShoppingCartLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { getALLCategory, getAllLabels, getAllProducts } from "../apis/config";
import { useDispatch } from "react-redux";
import { addToCart } from "../store/slices/CartSlice";
import ProductCard from "./ProductCard";
import ProductSkeleton from "./UI/ProductSkeleton";

const Products = () => {
  const [visible, setVisble] = useState(false);
  const [view, setView] = useState("grid");
  const [products, setProducts] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [labels,setLabels] = useState([])
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true); // start loading

    Promise.all([getALLCategory(), getAllProducts(), getAllLabels()])
      .then(([catRes, prodRes, labelRes]) => {
        setCategorys(catRes.data);
        setProducts(prodRes.data);
        setFilteredProducts(prodRes.data);
        setLabels(labelRes.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false)); // stop loading
  }, []);


  const handleAddProduct = (product) => {
    dispatch(addToCart({ ...product, quantity: 1 }));
  };

  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;
  // Pagination Logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;

 const handleSort = (e) => {
  const selectedLabel = e.target.value;

  if (!selectedLabel || selectedLabel === "all") {
    setFilteredProducts(products); // Reset
  } else {
    const filtered = products.filter((pro) => pro.label[0] === selectedLabel);
    setFilteredProducts(filtered);
    setCurrentPage(1); // Reset to page 1 on filter
  }
};

  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  return (
    <div className="">
      <div className=" flex justify-between flex-col gap-2 md:flex-row  text-gray-500">
        <select
          name="sort"
          id="sort"
          className="outline-none capitalize bg-none"
          onChange={handleSort}
        >
          <option value="all">{`sort by all`}</option>
          {
            labels.map((l,i)=>(<option key={i} value={l.name}>{`sort by ${l.name}`}</option>))}
        </select>

        <p className="p-1">Showing {indexOfFirstProduct + 1}–{Math.min(indexOfLastProduct, products.length)} of {products.length} results</p>
        <div className=" flex justify-center items-center gap-2 w-fit p-1">
          <GrGrid
            className={` cursor-pointer ${
              view === "grid" ? "text-primary" : "text-gray-700"
            }`}
            onClick={() => setView("grid")}
          />
          <GrList
            className={`cursor-pointer ${
              view === "list" ? "text-primary" : "text-gray-700"
            }`}
            onClick={() => setView("list")}
          />
        </div>
      </div>
      {view === "grid" && (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 justify-between py-10">
            {loading
              ? [...Array(12)].map((_, i) => <ProductSkeleton key={i} />)
              : currentProducts.map((data, index) => (
                  <ProductCard key={index} data={data} />
                
            // <div
            //   key={index}
            //   className="flex w-[166px] sm:w-[261px] mx-auto flex-col justify-center "
            // >
            //   <div className=" w-[166px] sm:w-[261px] rounded-md relative flex justify-center items-center overflow-hidden ">
            //     <Link to={`/products/${data._id}`}>
            //       <img
            //         src={data.images[0]}
            //         alt="product"
            //         className=" w-full h-full object-cover object-center rounded-md hover:scale-110 duration-200 ease-in"
            //       />
            //     </Link>

            //     <div className=" bg-white rounded-md absolute sm:h-[45px] bottom-5 flex">
            //       <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:text-white hover:bg-black border-r-[1px]  cursor-pointer"
            //       onClick={()=>handleAddProduct(data)}>
            //         <RiShoppingCartLine />
            //       </div>
            //       <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:text-white hover:bg-black border-r-[1px] cursor-pointer">
            //         <FaRegHeart />
            //       </div>
            //       <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:text-white hover:bg-black border-r-[1px] cursor-pointer">
            //         <FaCodeCompare />
            //       </div>
            //       <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:text-white hover:bg-black  cursor-pointer">
            //         <FaEye />
            //       </div>
            //     </div>
            //     <span className=" bg-red-600 absolute text-[10px] px-2 py-1 text-white capitalize font-bold left-0 top-5">
            //       {data.label[0]}
            //     </span>
            //   </div>
            //   <div className=" flex flex-col w-full gap-1 py-2">
            //     <span className=" text-[12px] text-gray-600">
            //       {categorys.find((cate) => cate._id === data.category)?.name}
            //     </span>
            //     {/* <div className="flex items-center mt-1  text-gray-600">
            //     {[1, 2, 3, 4, 5].map((index) =>
            //       index <= data.rate ? (
            //         <FaStar key={index} color="#ffa569" />
            //       ) : (
            //         <FaRegStar key={index} />
            //       )
            //     )}
            //   </div> */}
            //     <h4 className=" text-[15px] font-bold hover:text-purple-600 cursor-pointer w-fit">
            //       <Link to={`/products/${data._id}`}>{data.name}</Link>
            //     </h4>
            //     <h4 className=" text-[15px] font-boldw-fit text-red-600 font-bold">
            //       {" "}
            //       &#8377; {data.salePrice}{" "}
            //       <span className=" line-through text-gray-700 font-normal text-[12px]">
            //         &#8377; {data.price}
            //       </span>
            //     </h4>
            //   </div>
            // </div>
          ))}
        </div>
      )}
      {view === "list" && (
        <div className=" flex flex-col gap-6  py-10">
          {currentProducts.map((data, index) => (
            <div
              key={index}
              className="flex w-full mx-auto justify-center gap-5 "
            >
              <div className="w-[180px] h-[180px] sm:w-[200px]  sm:h-[200px] md:w-[266px]  md:h-[266px] rounded-md relative flex justify-center items-center overflow-hidden ">
                {/* <Link to={`/products/${data._id}`}> */}
                <img
                  src={data.images[0]}
                  alt="product"
                  className=" w-full h-full object-cover object-center rounded-md hover:scale-110 duration-200 ease-in"
                />
                {/* </Link> */}

                <span className=" bg-red-600 absolute text-[10px] px-2 py-1 text-white capitalize font-bold left-0 top-5">
                  {data.label[0]}
                </span>
              </div>
              <div className=" flex flex-col w-[60%] gap-1 py-2">
                <h4 className=" text-[16px] sm:text-[18px] font-bold hover:text-purple-600 cursor-pointer w-fit">
                  <Link to={`/products/${data._id}`}>{data.name}</Link>
                </h4>
                <span className="text-[12px] sm:text-[14px] text-gray-600">
                  {categorys.find((cate) => cate._id === data.category)?.name}
                </span>
                <h4
                  className=" sm:hidden text-[12px] w-full"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                >
                  {/* {data.description.slice(0, 30)}.... */}
                </h4>
                <h4
                  className=" hidden sm:block text-[16px] w-full"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                ></h4>

                {/* <div className="flex items-center mt-1  text-gray-600">
                  {[1, 2, 3, 4, 5].map((index) =>
                    index <= data.rate ? (
                      <FaStar key={index} color="#ffa569" />
                    ) : (
                      <FaRegStar key={index} />
                    )
                  )}
                </div> */}
                <h4 className=" sm:text-[18px] text-[14px] font-boldw-fit text-red-600 font-bold">
                  {" "}
                  &#8377; {data.salePrice}{" "}
                  <span className=" line-through text-gray-700 font-normal text-[12px]">
                    &#8377; {data.price}
                  </span>
                </h4>
                <div className=" bg-black w-fit sm:h-[45px] flex text-white">
                  <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:bg-primary border-r-[1px]  cursor-pointer" 
                  onClick={()=>handleAddProduct(data)}>
                    <RiShoppingCartLine />
                  </div>
                  <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:bg-primary border-r-[1px] cursor-pointer">
                    <FaRegHeart />
                  </div>
                  <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:bg-primary border-r-[1px] cursor-pointer">
                    <FaCodeCompare />
                  </div>
                  <div className=" p-2 w-[36px] sm:w-[55px] flex justify-center items-center hover:bg-primary  cursor-pointer"
                  onClick={()=>navigate(`/products/${data._id}`)}>
                    <FaEye />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Pagination Controls */}
      {products.length > productsPerPage && <Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={(page) => paginate(page)}
/>}
    </div>
  );
};

export default Products;

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  // Build the page list with ellipsis logic
  const getPages = () => {
    const pages = [];
    const delta = 2; // how many pages to show around current

    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1); // always show first page

    if (left > 2) pages.push("ellipsis-left");

    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    if (right < totalPages - 1) pages.push("ellipsis-right");

    if (totalPages > 1) pages.push(totalPages); // always show last page

    return pages;
  };

  return (
    <div className="flex justify-center mt-10 gap-2">

      {/* Previous */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
      >
        <GrPrevious />
      </button>

      {/* Page Buttons */}
      {getPages().map((page, index) => {
        if (page === "ellipsis-left" || page === "ellipsis-right") {
          return (
            <span key={index} className="px-3 py-2 text-gray-500 select-none">
              ...
            </span>
          );
        }

        const active = currentPage === page;

        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`px-3 py-2 rounded ${
              active
                ? "bg-primary text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {page}
          </button>
        );
      })}

      {/* Next */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
      >
        <GrNext />
      </button>

    </div>
  );
};

